import { z } from 'zod/v4';

// Базовая схема (VMAgentDTO), от которой строятся остальные
export const VMAgentDTO = z.object({
  id: z.string(),
  name: z.string(),
  label: z.string(),
  config: z.string(),
  tags: z.array(z.string()),
  enabled: z.boolean(),
  url: z.string().nullish(),
  api_base_url: z.string().nullish(),
  jobs: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      label: z.string(),
    }),
  ),
});
export type VMAgent = z.infer<typeof VMAgentDTO>;

export const VMAgentItemDTO = VMAgentDTO.pick({
  id: true,
  name: true,
  label: true,
  tags: true,
  jobs: true,
});
export type VMAgentItem = z.infer<typeof VMAgentItemDTO>;

export const VMAgentCreateTypeDTO = VMAgentDTO.omit({
  id: true,
  jobs: true,
}).extend({
  job_names: z.array(z.string()),
});
export type VMAgentTypeCreateRequest = z.infer<typeof VMAgentCreateTypeDTO>;

export const VMAgentTypeUpdateRequestDTO = VMAgentDTO.omit({
  id: true,
  name: true,
  url: true,
  jobs: true,
}).extend({
  job_names: z.array(z.string()),
});
export type VMAgentTypeUpdateRequest = z.infer<
  typeof VMAgentTypeUpdateRequestDTO
>;

export const VMAgentJobDTO = z.object({
  id: z.string(),
  name: z.string(),
  label: z.string(),
});
export type VMAgentJob = z.infer<typeof VMAgentJobDTO>;

// Сгруппированный агент
export const GroupedVMAgentDTO = VMAgentDTO.pick({
  name: true,
  label: true,
}).extend({
  jobs: z.array(VMAgentJobDTO),
});
export type GroupedVMAgent = z.infer<typeof GroupedVMAgentDTO>;